import { TopGame } from '../../top-game/types/TopGame'

export const filterGameIds = (topGames: TopGame[], start: number, end: number) => {
  return topGames
    .map((game) => game.gameId)
    .filter((gameId) => !!gameId)
    .slice(start, end)
}
